import { Outlet } from "react-router"
import type { RouteObject } from "react-router"

import { FeatureGuard } from "@/components/route/featureGuard/featureGuard"
import { NeatPath, RootPath } from "@/models/route"

import { InsightsIndexRoute } from "./pages/insights-index-route"
import { RecommendedActionsRoute } from "./pages/recommended-actions-route"
import { ScheduleMisalignmentDetailRoute } from "./pages/schedule-misalignment-route"
import { VarianceRoute } from "./pages/variance-route"

export const insightsRoutes: RouteObject[] = [
  {
    path: RootPath.Neat,
    element: (
      <FeatureGuard allowAdmin feature="neat_insights">
        <Outlet />
      </FeatureGuard>
    ),
    children: [
      { index: true, element: <InsightsIndexRoute /> },
      {
        path: NeatPath.RecommendedActions,
        element: <RecommendedActionsRoute />,
      },
      {
        // Per-site E2 detail lives UNDER the actions aggregator (the ACT list):
        // /neat/actions/schedule-misalignment/:siteId. There is no standalone
        // schedule-misalignment roster — the aggregator table is the list.
        path: `${NeatPath.RecommendedActions}/${NeatPath.ScheduleMisalignment}/:siteId`,
        element: <ScheduleMisalignmentDetailRoute />,
      },
      { path: NeatPath.Variance, element: <VarianceRoute /> },
    ],
  },
]
